import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import DataTable from 'datatables.net-react';
import * as BullCache from "../../util/BullCache";
import { PositionServices } from '../../services/PositionServices';
import "../custom.css";

function PositionQty() {
  const [loading, setLoading] = useState(false);
  const [positionData, setPositionData] = useState([]);

  var user = BullCache.getFromCache("user");

  useEffect(() => {
    fetchPositionQty();
  }, []);

  const fetchPositionQty = () => {
    setLoading(true);
    const dataToSubmit = {
      adminId: user.adminId,
      loginId: user.adminId,
    };

    PositionServices.getPositionOnlyQty(dataToSubmit).then((resp) => {
      setLoading(false);
      if (resp.code === 1 && resp.data && resp.data.positionList) {
        const mapped = [];
        resp.data.positionList.forEach((item) => {
          const clientName = item.user
            ? `${item.user.firstName} (${item.user.userName}) / ${item.user.admin || ''}`
            : '';
          const userId = item.user ? item.user.userid : '';

          if (item.position && item.position.length > 0) {
            item.position.forEach((p) => {
              const scriptNameParts = (p.scriptName || '').split('#');
              const segment = scriptNameParts[0] || '';
              const symbol = scriptNameParts[1] || '';
              const expiry = scriptNameParts[2] || '';

              mapped.push({
                client: clientName,
                userId: userId,
                segment: segment,
                script: symbol,
                expiry: expiry,
                type: p.type || '',
                qty: p.qty || 0,
                lot: p.lot || 0,
                buyQty: p.totalBuyQty || 0,
                sellQty: p.totalSellQty || 0,
                buyLot: p.totalBuyLot || 0,
                sellLot: p.totalSellLot || 0,
              });
            });
          }
        });
        setPositionData(mapped);
      } else {
        setPositionData([]);
      }
    }).catch(() => {
      setLoading(false);
      setPositionData([]);
    });
  };

  return (
    <div>
      {loading ? (
        <div className="container vh-100">
          <div className="d-flex align-items-center justify-content-center h-90">
            <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
      <Card className="mt-2 mb-5">
        <Card.Body>
          <div className="table-responsive">
            <DataTable
              id="positionQtyTable"
              className="mt-1 table table-striped text-center bg-secondary-row fss-08 table-responsive"
              options={{
                pageLength: 50,
                order: [],
                language: {
                  emptyTable: 'No Data Found',
                  lengthMenu: 'entries per page _MENU_',
                },
              }}
              columns={[
                { title: 'CLIENT', data: 'client' },
                { title: 'SEGMENT', data: 'segment' },
                { title: 'SCRIPT', data: 'script' },
                { title: 'EXPIRY', data: 'expiry' },
                { title: 'TYPE', data: 'type' },
                { title: 'QTY', data: 'qty' },
                { title: 'LOT', data: 'lot' },
                { title: 'BUY QTY', data: 'buyQty' },
                { title: 'SELL QTY', data: 'sellQty' },
                { title: 'BUY LOT', data: 'buyLot' },
                { title: 'SELL LOT', data: 'sellLot' },
              ]}
              data={positionData}
            />
          </div>
        </Card.Body>
      </Card>
      )}
    </div>
  );
}

export default PositionQty;
